import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Tooltip, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import instId from "./network/instituteId";
import Network from "./network/Network";


export const ReelsSection = ({ endpointsUrl }) => {

    const isMobile = useMediaQuery("(min-width:600px)");
    const [shortsList, setShortsList] = useState([]);
    const [peviewImgVideo, setPeviewImgVideo] = useState({});

    useEffect(() => {
        getBanners();

    }, []);

    const getBanners = async () => {
        const body = {
            page: 0,
            pageSize: 500
        }
        try {
            const response = await Network.getShortsApi(body, instId);

            const fetchedBanners = response.videos || [];
            if (fetchedBanners.length > 0) {
                setShortsList(fetchedBanners);
            } else {
                setShortsList([]);
            }
        } catch (error) {
            setShortsList([]);
        }
    };

    const handlePreview = (url, type, itemId) => {
        setPeviewImgVideo((prev) => ({ ...prev, [itemId]: { url, type } }));
    };

    return (
        <>
            {
                shortsList?.length > 0 && (
                    <Box id="whyfast" className="text-center"
                        sx={{
                            paddingLeft: isMobile ? '6rem' : '1rem', paddingRight: isMobile ? '6rem' : '1rem', paddingTop: isMobile ? '3rem' : '1rem', paddingBottom: isMobile ? '3rem' : '1rem', position: "relative", mb: 2
                            // background: "#00246080" 
                        }}

                    //  sx={{ mt: 3, mb: 8, padding: "0rem 0rem" }}
                    >
                        {
                            shortsList?.length > 0 && (
                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Swiper
                                            navigation={{
                                                nextEl: ".swiper-button-next",
                                                prevEl: ".swiper-button-prev",
                                            }}
                                            // loop={true}
                                            className="swiper-container"
                                            breakpoints={{
                                                320: { slidesPerView: 1 },
                                                768: { slidesPerView: 2 },
                                                1024: { slidesPerView: 5 }
                                            }}
                                            spaceBetween={10}
                                            // navigation={true}
                                            pagination={false}
                                            modules={[Navigation]}
                                        >
                                            {shortsList && shortsList.map((item, i) => (
                                                <SwiperSlide key={i}>
                                                    <Grid item xs={12} sm={12} md={12} lg={12} sx={{ padding: isMobile ? "10px" : "20px", textAlign: "center" }}>
                                                        <Box sx={{
                                                            borderRadius: "10px", position: "relative",
                                                            // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                                                            //  height: "300px"
                                                        }}>
                                                            <video
                                                                src={endpointsUrl + item?.video}
                                                                autoPlay
                                                                muted
                                                                loop
                                                                playsInline
                                                                onClick={(e) => {
                                                                    e.target.paused ? e.target.play() : e.target.pause();
                                                                }}
                                                                style={{
                                                                    width: "100%",
                                                                    height: "400px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "10px",
                                                                    cursor: "pointer"
                                                                }}
                                                            />
                                                            <Box sx={{
                                                                mt: 1,
                                                                // position: "absolute",
                                                                // bottom: "10px",
                                                                // left: "15px",
                                                                color: "black",
                                                                // backgroundColor: "rgba(0, 0, 0, 0.5)",
                                                                // padding: "4px 8px",
                                                                borderRadius: "4px",
                                                                fontSize: "12px"
                                                            }}>
                                                                {item?.caption}
                                                            </Box>
                                                        </Box>
                                                    </Grid>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                        <div className="swiper-button-prev"></div>
                                        <div className="swiper-button-next"></div>
                                    </Grid>
                                </Grid>
                            )
                        }
                    </Box>
                )
            }
        </>
    );
};
